import { computed } from 'vue';
import { IconKey, IconLogout, IconUserCircle } from '@tabler/icons-vue';
import { useUser } from '@/composables/useUser';

export const useUserMenuItems = () => {
    const user = useUser();

    const items = computed(() => [
        { type: 'label', label: user.value.name, sublabel: user.value.email },
        { type: 'separator' },
        { label: 'Account instellingen', icon: IconUserCircle, href: route('account.profile') },
        { label: 'Wachtwoord wijzigen', icon: IconKey, href: route('account.security') },
        { type: 'separator' },
        { label: 'Uitloggen', icon: IconLogout, href: route('logout'), method: 'post' },
    ]);

    return { items };
};
